import React from "react";
import { currencyFormatter, formatDateTime, shrinkText } from "../../Helpers/Utils";
import { Skeleton } from "../../Components/Needed";

const RecentBookings = ({ list, loading }) => {
    if (loading) {
        return (
            <div>
                {[0, 1, 2, 3].map((i) => <Skeleton key={i} height={22} className="mb-2" />)}
            </div>
        );
    }

    if (!list?.length) {
        return <div className="mini-table-empty">No bookings created yet.</div>;
    }

    return (
        <div className="mini-table-wrap">
            <table className="mini-table">
                <thead>
                    <tr>
                        <th>Booking</th>
                        <th>Customer</th>
                        <th>Car</th>
                        <th>Stage</th>
                        <th className="text-end">Amount</th>
                        <th>Created</th>
                    </tr>
                </thead>
                <tbody>
                    {list.map((item) => (
                        <tr key={item.bookingId}>
                            <td className="fw-semibold">{item.bookingId}</td>
                            <td>{shrinkText(item.customerName, 18) || "-"}</td>
                            <td>{item.registrationNo || "-"}</td>
                            <td>
                                <span className={`stage-pill stage-${item.bookingStage}`}>{item.bookingStage}</span>
                            </td>
                            <td className="text-end">{currencyFormatter(item.totalAmount)}</td>
                            <td className="text-muted">{formatDateTime(item.createdAt)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default RecentBookings;
